import React from "react";

import { Icon, IconSize } from "@gaming/xds-react-js";
import { Warning } from "@gaming/xds-react-js-icons";

import { useString } from "../../../../localization/localizationHelpers";
import * as styles from "./GameConceptTlaBanner.module.css";

type GameConceptTlaBannerProps = Readonly<{
  sentDate?: string;
}>;

export const GameConceptTlaBanner = ({ sentDate }: GameConceptTlaBannerProps) => {
  const title = useString("gameConceptTlaRequiredTitle");
  const subtitleWithoutDate = useString("gameConceptTlaSentSubtitle");
  const subtitleWithDate = useString("gameConceptTlaSentOnDateSubtitle", sentDate ?? "");
  const subtitle = sentDate ? subtitleWithDate : subtitleWithoutDate;

  return (
    <div className={styles.banner} role="status">
      <Icon aria-hidden="true" className={styles.icon} icon={Warning} iconSize={IconSize.Custom} />
      <div className={styles.content}>
        <p className={styles.title}>{title}</p>
        <p className={styles.subtitle}>{subtitle}</p>
      </div>
    </div>
  );
};
